"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACPhoneMasker = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ACPhoneMasker = function (_a) {
    var phoneNumber = _a.phoneNumber, _b = _a.className, className = _b === void 0 ? '' : _b;
    if (!phoneNumber || phoneNumber.replace(/\D/g, '').length !== 10) {
        return (0, jsx_runtime_1.jsx)("span", { className: className, children: "--" });
    }
    var cleanNumber = phoneNumber.replace(/\D/g, '');
    var firstTwo = cleanNumber.substring(0, 2);
    var lastThree = cleanNumber.substring(7, 10);
    var maskedPart = '*****';
    return ((0, jsx_runtime_1.jsxs)("span", { className: className, children: [firstTwo, maskedPart, lastThree] }));
};
exports.ACPhoneMasker = ACPhoneMasker;
